// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"950":"63096bd0","977":"917c71ae"}[chunkId] + ".chunk.js";
};